<main class="bg-white position-relative">
  <section class="signup-step-container padd-top-bot">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-12">
          <div class="wizard">
            <div class="wizard-inner">
              <div class="connecting-line"></div>
              <ul class="nav nav-tabs" role="tablist">
                <li class="active" role="presentation">
                  <a aria-controls="step1" aria-expanded="true" data-toggle="tab" href="#step1"
                     role="tab"><span class="round-tab">1 </span> <i>Confirm
                    Size</i></a>
                </li>
                <li class="disabled" role="presentation">
                  <a aria-controls="step2" aria-expanded="false" data-toggle="tab" href="#step2"
                     role="tab"><span class="round-tab">2</span> <i>Place Bid</i></a>
                </li>
              </ul>
            </div>

            <form class="login-box">
              <div class="tab-content" id="main_form">
                <div class="tab-pane active" id="step1" role="tabpanel">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div class="col-md-6 product-left">
                        <div class="buy-new-product-left">
                          <img alt="" class="img-fluid"
                               src="/assets/images/buy-now-product.png"/>
                        </div>
                      </div>
                      <div class="col-md-6 product-right">
                        <div class="buy-now-top-sec">
                          <div class="inner-buy-now inner-buy-now1">
                            <p>Buy or Bid</p>
                            <span><b>$215 </b> lowest ask</span>
                          </div>
                          <div class="inner-buy-now inner-buy-now2">
                            <p>Sell or Ask</p>
                            <span><b>$305 </b> highest BId</span>
                          </div>
                          <div class="inner-buy-now inner-buy-now3">
                            <p>Last Sale</p>
                            <div class="last-sale-price">
                              <h3>$273.00</h3>
                              <a href="#"><i aria-hidden="true"
                                             class="fa fa-arrow-down"></i> -$1 (0%)</a>
                            </div>
                          </div>
                        </div>
                        <h2 class="sec-heading">Off-White x Air Force 1 Low-Volt</h2>
                        <div class="select_filed size-selected">
                          <select aria-invalid="false"
                                  class="wpcf7-form-control wpcf7-select Wide"
                                  name="Selectbox">
                            <option value="AQI India">Size</option>
                            <option value="Second One">1</option>
                            <option value="Third one">2</option>
                          </select>
                        </div>
                        <div class="border-line"></div>
                        <div class="row release-date">
                          <div class="col-md-8 col-md-7">
                            <p>Release Date: <b>May 19, 2020</b></p>
                            <p>Colorway: <b>Black/White - Cone - Black</b></p>
                          </div>
                          <div class="col-md-4 col-md-4">
                            <p>SKU: <b>AO4606-700</b></p>
                            <p>Retail Price:<b> $65.00</b></p>
                          </div>
                        </div>
                        <ul class="list-inline confirm-btn">
                          <li>
                            <button
                              class="default-btn next-step text-uppercase open_sans bold_500 text-white bg_green shop_btn d-inline-block  mt-lg-2 mt-xl-4"
                              type="button">
                              confirm
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="step2" role="tabpanel">
                  <h2 class="sec-heading">Off-White x Air Force 1 Low-Volt</h2>
                  <div class="row padd-top-30">
                    <div class="col-md-6">
                      <div class="total-price-sec">
                        <h3>Total Price</h3>
                        <div class="border-line"></div>
                        <div class="shiping-sec-top">
                          <p>Ask</p>
                          <span>$100</span>
                        </div>
                        <div class="shiping-sec-top">
                          <p>Shipping </p>
                          <span>Shipping</span>
                        </div>
                        <div class="shiping-sec-top">
                          <p><b>Total</b></p>
                          <span><b>$105</b></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="total-price-sec total-price-sec2">
                        <h3>Place Bid</h3>
                        <div class="buy-now-field">
                          <input name="Lowest Bid" placeholder="Lowest Bid" type="text">
                          <span>$</span>
                        </div>
                        <div class="top_selling_product_box payouttt_offers_content">
                          <a class="text-uppercase open_sans bold_700 text-white shop_btn d-inline-block font_26"
                             data-target="#exampleModal"
                             data-toggle="modal"
                             href="javascript:void(0);">Confirm
                            Bid</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- Confirm Bid Modal -->
<div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="exampleModal" role="dialog"
     tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="success-checkmark">
          <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
            <div class="icon-fix"></div>
          </div>
        </div>
        <h2>Bid Completed</h2>
        <p>Thank you for ordering. We received your order and will begin processing it soon. Your order
          information appears below</p>
      </div>
    </div>
  </div>
</div>
